import React from 'react'
import PropTypes from 'prop-types'

const SharedClassIcon = ({ className, height, width, ...props }) => (
  <svg
    aria-hidden
    className={className}
    data-testid="shared-class-icon"
    fill="none"
    height={height}
    viewBox="0 0 12 9.00002"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.39998 7.80002V9.00002H0V7.80002C0 7.80002 0 5.40002 4.19999 5.40002C8.39998 5.40002 8.39998 7.80002 8.39998 7.80002ZM6.29998 2.10002C6.29998 1.68468 6.17682 1.27867 5.94607 0.933325C5.71532 0.587982 5.38735 0.318819 5.00362 0.159875C4.6199 0.000931144 4.19766 -0.0406559 3.7903 0.0403731C3.38294 0.121402 3.00876 0.321408 2.71507 0.615098C2.42138 0.908788 2.22137 1.28297 2.14035 1.69033C2.05932 2.09769 2.1009 2.51993 2.25985 2.90366C2.41879 3.28738 2.68795 3.61536 3.03329 3.84611C3.37864 4.07686 3.78465 4.20002 4.19999 4.20002C4.75694 4.20002 5.29108 3.97877 5.68491 3.58495C6.07874 3.19112 6.29998 2.65698 6.29998 2.10002ZM8.36398 5.40002C8.73283 5.68547 9.03464 6.04828 9.24818 6.46293C9.46172 6.87757 9.5818 7.33398 9.59998 7.80002V9.00002H12V7.80002C12 7.80002 12 5.62202 8.36398 5.40002ZM7.79998 2.20779e-05C7.38705 -0.0018986 6.98326 0.121541 6.64198 0.354022C7.00645 0.863264 7.20242 1.47379 7.20242 2.10002C7.20242 2.72625 7.00645 3.33678 6.64198 3.84602C6.98326 4.0785 7.38705 4.20194 7.79998 4.20002C8.35693 4.20002 8.89108 3.97877 9.2849 3.58495C9.67873 3.19112 9.89997 2.65698 9.89997 2.10002C9.89997 1.54307 9.67873 1.00892 9.2849 0.615098C8.89108 0.221272 8.35693 2.20779e-05 7.79998 2.20779e-05Z"
      fill="currentColor"
    />
  </svg>
)

SharedClassIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

SharedClassIcon.defaultProps = {
  height: 9,
  width: 12,
}

export default SharedClassIcon
